import { Loader } from 'google-maps';

/**
 * Initialize the google map.
 */
export const initMap = () => {
    // Get the Google Maps key from the first map.
    const key = document.querySelector('.c-map')?.dataset?.key;

    if (!key) return;

    const loader = new Loader(key);

    loader.load().then(google => {
        document.querySelectorAll('.c-map').forEach(map => {
            const lat = parseFloat(map.dataset.lat) || 0;
            const lng = parseFloat(map.dataset.lng) || 0;
            const zoom = parseInt(map.dataset.zoom) || 16;

            const location = { lat: lat, lng: lng };

            const gMap = new google.maps.Map(map, {
                zoom: zoom,
                center: location,
                styles: [
                    {
                        elementType: 'geometry',
                        stylers: [{ color: '#f5f5f5' }],
                    },
                    {
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#f5f5f5' }],
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#bdbdbd' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [{ color: '#eeeeee' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{ color: '#e5e5e5' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#ffffff' }],
                    },
                    {
                        featureType: 'road.arterial',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#dadada' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'geometry',
                        stylers: [{ color: '#e5e5e5' }],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'geometry',
                        stylers: [{ color: '#eeeeee' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#c9c9c9' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry.fill',
                        stylers: [{ color: '#cae8f3' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                ],
            });

            const marker = new google.maps.Marker({
                position: location,
                map: gMap,
                icon: '/_Resources/Static/Packages/JvMTECH.Site/Assets/Icons/DKZ_Map_Pin.svg',
            });
        });
    });
};
